import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { keyframes, style } from '@vanilla-extract/css';

export const sidebarRoot = style(
  {
    backgroundColor: themeVars.color['surface-content'],
    width: '100%',
    height: '100%',
    borderLeft: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
    boxSizing: 'border-box',
    /* Clips content during width animation for smooth drawer open */
    overflow: 'hidden',
  },
  'sidebar-root',
);

export const sidebarRootLayoutRefresh = style(
  {
    border: 'none',
    borderRadius: `${themeVars.radius['10']} ${themeVars.radius['10']} 0 0`,
    marginRight: themeVars.space['150'],
  },
  'sidebar-root-layout-refresh',
);

const TOP_NAVIGATION_HEIGHT = '44px';

export const sidebarRootCompanion = style(
  {
    borderRadius: 0,
    marginRight: 0,
    marginTop: `-${TOP_NAVIGATION_HEIGHT}`,
    height: `calc(100% + ${TOP_NAVIGATION_HEIGHT})`,
    borderLeft: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
  },
  'sidebar-root-companion',
);

export const sidebar = style(
  {
    height: '100%',
    width: '100%',
  },
  'sidebar',
);

export const resizeHandleLayoutRefresh = style(
  {
    // Rendered as a flex item outside the overflow:hidden sidebar container.
    // Negative margins let it overlap the content's paddingRight (left) and the
    // sidebar edge (right) so it fills the visual gap without affecting layout.
    position: 'relative',
    width: '14px',
    flexShrink: 0,
    cursor: 'ew-resize',
    marginLeft: `calc(-1 * ${themeVars.space['150']})`,
    marginRight: '-2px',
    zIndex: 41,
    '::after': {
      content: '""',
      position: 'absolute',
      right: '2px',
      top: 0,
      width: '1px',
      height: '100%',
      backgroundColor: themeVars.color['scope-neutral-border'],
      opacity: 0,
      transition: 'opacity 100ms ease-in-out',
    },
    selectors: {
      '&:hover::after': {
        opacity: 1,
      },
      '&:active::after': {
        opacity: 1,
      },
    },
  },
  'resize-handle-layout-refresh',
);

export const sidebarHeader = style(
  {
    height: '44px',
  },
  'sidebar-header',
);

const attentionFadeIn = keyframes({ from: { opacity: 0 }, to: { opacity: 1 } }, 'sidebar-attention-fade-in');

/**
 * The AI gradient ring on the panel's edge while it waits on the person. A
 * masked pseudo-element, so it never paints over the panel's content, and it
 * inherits the root's radius so it follows the companion-mode reshaping.
 */
export const sidebarRootAttention = style(
  {
    '::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      zIndex: 1,
      pointerEvents: 'none',
      borderRadius: 'inherit',
      padding: themeVars.border['width-025'],
      background: `linear-gradient(135deg, ${themeVars.color['ai-ring-stop-02']}, ${themeVars.color['ai-ring-stop-03']})`,
      WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'xor',
      mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      maskComposite: 'exclude',
      animation: `${attentionFadeIn} ${themeVars.motion['duration-moderate-01']} ${themeVars.motion['easing-entrance-expressive']} both`,
    },
    '@media': {
      '(prefers-reduced-motion: reduce)': {
        '::before': {
          animation: 'none',
        },
      },
    },
  },
  'sidebar-root-attention',
);
